import { AxiosCore } from "../utils/AxiosCore"


export const login = async(data) => {
    return await AxiosCore.post("/oauth2/v1/token/login", data)
}


export const logout = async (token) => {
    return await AxiosCore.get("/oauth2/v1/token/logout", {
        headers: { Authorization: "Bearer " + token },
    });
}


export const validateToken = async (token) =>{
    return await AxiosCore.get("/oauth2/v1/token/validate", {
        headers: { Authorization: "Bearer " + token },
    });
}
